import React from 'react';
import { motion } from 'framer-motion';
export function Promise() {
  return <section className="py-24 px-4 bg-violet-900 text-white" data-id="element-116">
      <div className="max-w-5xl mx-auto text-center" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-118">
          <h2 className="font-playfair text-4xl md:text-5xl font-bold mb-8" data-id="element-119">
            Y si te Dijera que…
          </h2>

          <div className="my-12" data-id="element-120">
            <p className="font-playfair text-7xl md:text-9xl font-bold mb-8 text-violet-50" data-id="element-121">
              En 5 minutos.
            </p>
          </div>

          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto leading-relaxed font-light" data-id="element-122">
            Puedes tener una página web real, bonita, publicada en internet con
            tu dominio — construida enteramente por IA mientras tú solo le dices
            qué quieres.
          </p>

          <p className="text-2xl md:text-3xl font-bold text-violet-50" data-id="element-123">
            Eso es exactamente lo que aprenderás el 22 de abril.
          </p>
        </motion.div>
      </div>
    </section>;
}